import { useContext } from "react";
import { snackbarContext } from "../context/SnackbarContext";

// eslint-disable-next-line import/prefer-default-export
export const useSnackbar = () => {
  const snackbar = useContext(snackbarContext);

  return snackbar;
};
